import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { iconProductMessagePicker } from '../../helpers/IconHelper';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    padding: 12,
    boxSizing: 'border-box',
    borderRadius: (props) =>
      props.rounded ? '0px 0px 8px 8px' : props.fullRounded ? '4px' : '',
  },
  success: {
    border: '1px solid #007e2e',
    background: 'rgba(0,131,48,0.12)',
  },
  alert: {
    border: '1px solid #FFCC00',
    background: 'rgba(255,204,0,0.12)',
  },
  error: {
    border: '1px solid #EB0043',
    background: 'rgba(235,0,67,0.12)',
  },
  info: {
    border: '1px solid #5b73ba',
    background: 'rgba(91, 115, 186, 0.12)',
  },
  image: {
    width: 20,
    height: 20,
    marginRight: 12,
  },
  text: {
    fontSize: 16,
    color: '#1a1a1a',
  },
  innerContainer: {
    backgroundColor: 'green',
    margin: '-12px',
    marginTop: 5,
    padding: '5px 12px',
    borderRadius: (props) =>
      props.rounded ? '0px 0px 8px 8px' : props.fullRounded ? '4px' : '',
  },
}));

const Message = ({ ...props }) => {
  const {
    severity,
    message,
    rounded,
    fullRounded,
    hasInfoBelow,
    infoBelow,
  } = props;

  const classes = useStyles({ severity, rounded, fullRounded });

  return (
    <Box className={`${classes.container} ${classes[severity]}`}>
      <Box display="flex" data-cy="message">
        <img
          className={classes.image}
          src={iconProductMessagePicker(severity)}
        />
        <Typography className={classes.text}>{message}</Typography>
      </Box>
      {hasInfoBelow && (
        <Box className={`${classes.innerContainer} ${classes[severity]}`}>
          <Typography className={classes.text}>{infoBelow}</Typography>
        </Box>
      )}
    </Box>
  );
};

Message.propTypes = {
  severity: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  rounded: PropTypes.bool,
  fullRounded: PropTypes.bool,
  hasInfoBelow: PropTypes.bool,
  infoBelow: PropTypes.object,
};

export default Message;
